export default {
  modal: {
    defaultTitle: "付费提醒",
    defaultMessage: "请前往控制台管理订阅与额度。",
    primaryLabel: "前往控制台",
    secondaryLabel: "关闭",
  },
  notices: {
    oneOffExpiring: {
      title: "额度即将到期",
      message: "您的一次性积分将在 3 天内过期，请及时续费以不中断分析。",
      primaryLabel: "立即续费",
      secondaryLabel: "稍后再说",
    },
    lowCredits: {
      title: "积分不足提醒",
      message: "您的积分已低于 5，请及时充值以继续使用高级分析。",
      primaryLabel: "立即充值",
      secondaryLabel: "暂不需要",
    },
    insufficientCredits: {
      title: "积分不足",
      message:
        "该功能需要 {requiredCredits} 积分，但您当前只有 {totalCredits}。",
      primaryLabel: "立即充值",
      secondaryLabel: "取消",
    },
    trialCreditsGranted: {
      title: "欢迎积分已就位！",
      message: "您已获得 {granted} 积分试用额度，上传一张图片即可开始体验 PhotoScope。",
      primaryLabel: "立即开始",
      secondaryLabel: "稍后再说",
    },
    trialCreditsGrantedGeneric: {
      title: "欢迎积分已就位！",
      message: "您的账户已新增试用积分，上传一张图片即可开始体验。",
      primaryLabel: "立即开始",
      secondaryLabel: "稍后再说",
    },
    creditReminder: {
      title: "您的积分正在等待",
      message: "您还没有使用过试用积分。上传一张图片，立即感受 PhotoScope 的效果。",
      primaryLabel: "立即上传",
      secondaryLabel: "稍后提醒我",
    },
  },
};
